import { api } from '_/services/api';
import { store } from '_/vuex/store';

(function ($) {
    $.Redactor.prototype.ai = function () {
        return {
            langs: {
                en: {
                    'ai': 'AI Edit',
                    'system-prompt': 'System Prompt',
                    'processing': 'Processing...',
                },
            },

            getTemplate: function () {
                return (
                    String() +
                    '<div class="modal-section" id="redactor-modal-ai-edit">' +
                    '<section>' +
                    '<label>' + this.lang.get('system-prompt') + '</label>' +
                    '<textarea id="redactor-ai-system-prompt-area" style="height: 160px;">' + 
                    (this.opts.aiSystemPrompt || 'Use a professional tone to write a short paragraph about the given text. Always format response as HTML making sure that paragraphs are wrapped in p tags. Also feel free to use H2, and subsequent H tags, but H1 is already reserved - dont use H1. You can use bold, italic as required, and don\'t change other elements such as images or other embeds - you should leave them as is.') + 
                    '</textarea>' +
                    '</section>' +
                    '<section>' +
                    '<button id="redactor-modal-button-action">Process with AI</button>' +
                    '<button id="redactor-modal-button-cancel">Cancel</button>' +
                    '</section>' +
                    '</div>'
                );
            },

            init: function () {
                var button = this.button.addAfter('image', 'ai', this.lang.get('ai'));
                this.button.setIcon(button, '<i class="fal fa-sparkles"></i>');
                this.button.addCallback(button, this.ai.show);
            },

            show: function () {
                this.modal.addTemplate('ai', this.ai.getTemplate());
                this.modal.load('ai', this.lang.get('ai'), 700);

                // action button
                this.modal.getActionButton()
                    .text('Process with AI')
                    .off('click')
                    .on('click', this.ai.process.bind(this));

                this.modal.show();

                // focus
                if (this.detect.isDesktop()) {
                    setTimeout(function () {
                        $('#redactor-ai-system-prompt-area').focus();
                    }, 1);
                }
            },

            process: function () {
                const systemPrompt = $('#redactor-ai-system-prompt-area').val();
                const editorContent = this.code.get();
                const actionButton = this.modal.getActionButton();
                
                // Disable the button and show processing state
                actionButton.prop('disabled', true);
                actionButton.text(this.lang.get('processing'));

                // Get the current locale from Vuex store
                const targetLanguageCode = store.state.ui.localesHeaderParameter.split(',')[0];
                
                const payload = {
                    system_prompt: systemPrompt,
                    text: editorContent,
                    target_language_code: targetLanguageCode
                };

                api.post('ai/edit', payload)
                    .then(response => {
                        if (response.body.message === 'AI_EDIT_SUCCESS') {
                            this.code.set(response.body.body.edited_text);
                            this.modal.close();
                        } else {
                            throw new Error('AI processing failed');
                        }
                    })
                    .catch(error => {
                        console.error('AI processing error:', error);
                        alert('An error occurred while processing your request.');
                    })
                    .finally(() => {
                        actionButton.prop('disabled', false);
                        actionButton.text('Process with AI');
                    });
            },
        };
    };
})(jQuery);
